import { useContext } from 'react';
import styles from './DirectoryCardArea.module.scss';
import DirectoryCard from './directory-card/DirectoryCard';
import { AppContext } from '../../context/AppContext';
import { DirectoryListType } from '../directory-list/DirectoryList';
import { DentistIcon, DoctorIcon, HospitalIcon, PharmacyIcon, EarIcon, CarIcon, SearchIcon } from '../icons/Icons';

// controls the lables 
const DirectoryCardArea = (props: any) => {
  const appContext = useContext(AppContext);
  let currentListType: DirectoryListType;

  switch (appContext.directoryListType) {
    case DirectoryListType.doctor:
      currentListType = DirectoryListType.doctor;
      break;
    case DirectoryListType.facility:
      currentListType = DirectoryListType.facility;
      break;
    case DirectoryListType.pharmacy:
      currentListType = DirectoryListType.pharmacy;
      break;
    case DirectoryListType.dentist:
      currentListType = DirectoryListType.dentist;
      break;
    case DirectoryListType.hearingAid:
      currentListType = DirectoryListType.hearingAid;
      break;
    case DirectoryListType.transportation:
      currentListType = DirectoryListType.transportation;
      break;
    case DirectoryListType.all:
      currentListType = DirectoryListType.all;
      break;
    case DirectoryListType.phone:
      currentListType = DirectoryListType.phone;
      break;
    default:
      currentListType = DirectoryListType.none;
      break;
  }

  return (
    <div className={styles.directoryCardContainer}>
      <DirectoryCard title="Doctor" currentListType={currentListType} listType={DirectoryListType.doctor}>
        <DoctorIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.doctor} />
      </DirectoryCard>
      <DirectoryCard title="Hospital, facility, or other service" currentListType={currentListType} listType={DirectoryListType.facility}>
        <HospitalIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.facility} />
      </DirectoryCard>
      <DirectoryCard title="Pharmacy" currentListType={currentListType} listType={DirectoryListType.pharmacy}>
        <PharmacyIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.pharmacy} />
      </DirectoryCard>
      <DirectoryCard title="Dentist" currentListType={currentListType} listType={DirectoryListType.dentist}>
        <DentistIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.dentist} />
      </DirectoryCard>
      <DirectoryCard title="Hearing Aids" currentListType={currentListType} listType={DirectoryListType.hearingAid}>
        <EarIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.hearingAid} />
      </DirectoryCard>
      <DirectoryCard title="Transportation" currentListType={currentListType} listType={DirectoryListType.transportation}>
        <CarIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.transportation} />
      </DirectoryCard>
      <DirectoryCard title="Find by name or keyword" currentListType={currentListType} listType={DirectoryListType.all}>
        <SearchIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.all} />
      </DirectoryCard>
      <DirectoryCard title="Find by phone number" currentListType={currentListType} listType={DirectoryListType.phone}>
        <SearchIcon isActive={appContext.isDirectorySelected && appContext.directoryListType === DirectoryListType.phone} />
      </DirectoryCard>

    </div>
  );
};

export default DirectoryCardArea;
